import React, { useEffect, useState } from "react";
import "./faq.scss";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import AutoComplete from "rsuite/AutoComplete";
import Table from "react-bootstrap/Table";
import axios from "axios";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";

function Faq() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idFaq, setIdFaq] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/faqs");
    const category = result.data.data.map((value) => value.category);
    setAutoComplete(category);
    setData(result.data.data);
    setGetSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [deleteSuccess, itemOffset, itemsPerPage, getSuccess]);

  //Handle search
  const keys = ["category", "question"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const faq = handleSearch();
  const dataTable = faq ? faq : currentItems;

  //Handle Delete
  const deleteFaq = async (id) => {
    setIdFaq(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    const result = await axios.delete(
      `https://mobile.amospa.com/faqs/${idFaq}`
    );
    setDeleteSuccess(result);
    setModalShow(false);
    window.location.reload();
  };

  return (
    <div className="faq">
      <div className="header-faq py-4">
        <span className="d-flex align-items-center">
          <h3 className="mx-2 text-white">List FAQ</h3>
          <p>
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </p>
        </span>
        <span className="d-flex">
          <Link to={"/homepage/setting/faq/addfaq"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD FAQ
            </button>
          </Link>
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover className="m-0">
        <thead>
          <tr>
            <th>NO</th>
            <th>CATEGORY</th>
            <th>QUESTIONS</th>
            <th>ANSWER</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item ? item.category : ""}</td>
              <td>{item ? item.question : ""}</td>
              <td>{item ? item.answer : ""}</td>
              <td>
                <Link to={`/homepage/setting/faq/editfaq/${item.id}`}>
                  <button
                    className="btn-staffid ms-2 bg-warning text-dark py-1 px-3"
                    style={{ borderRadius: "10px" }}
                  >
                    Edit
                  </button>
                </Link>
                <button
                  className="btn-staffid ms-2 bg-danger px-2 py-1"
                  onClick={() => deleteFaq(item.id)}
                  style={{ borderRadius: "10px" }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="footer-faq py-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div className="footer-faq-rigth">
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Delete FAQ ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Faq;
